module.exports = __webpack_public_path__ + "img/breadface.6e10c116.jpg";